var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeLockedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-NG-1---Time-locked",
    transform: "translate(-237 -74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(237 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fill: "#F54100"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22,
    cy: 22,
    r: 22
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.925 28.363c.05-3.345 2.927-6.064 6.44-6.134.046.002.09.006.135.006.045 0 .09-.004.134-.006 3.514.07 6.392 2.789 6.441 6.134.002.112.002 2.838.002 4.166H15.923c0-1.328 0-4.054.002-4.166m0-13.744c-.002-.112-.002-2.812-.002-4.148h13.154c0 1.336 0 4.038-.002 4.148-.05 3.346-2.927 6.063-6.44 6.134-.046-.002-.09-.007-.135-.007-.045 0-.09.005-.134.007-3.514-.07-6.392-2.788-6.441-6.134m15.344 17.91h-.73c0-4.154-.002-4.186-.002-4.186-.044-3.02-1.937-5.628-4.626-6.852 2.69-1.222 4.58-3.823 4.626-6.83l.001-4.19h.731c.404 0 .731-.328.731-.736A.733.733 0 0031.27 9H13.73c-.403 0-.73.33-.73.735 0 .408.327.736.73.736h.732l.001 4.169c.044 3.02 1.937 5.628 4.626 6.851-2.69 1.222-4.58 3.824-4.626 6.83l-.001 4.208h-.731c-.404 0-.731.33-.731.736 0 .407.327.735.73.735h17.54c.403 0 .73-.328.73-.735a.733.733 0 00-.73-.736",
    id: "timer",
    fill: "#FFF"
  }))))));
}

SvgTimeLockedIcon.displayName = 'TimeLockedIcon';
export default SvgTimeLockedIcon;